function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// ----------------------------------------------------------------------------

declare global {
    interface String {
        capitalize(): string;
    }
}

// ----------------------------------------------------------------------------

String.prototype.capitalize = function (): string {
    return capitalizeFirstLetter(this as string);
};

// ----------------------------------------------------------------------------

export default capitalizeFirstLetter;
